import {
  FiActivity,
  FiFileText,
  FiUsers,
  FiDollarSign,
  FiTrendingDown,
  FiTrash2,
} from 'react-icons/fi';

export function timeAgo(dateString) {
  if (!dateString) return '';
  const diffInSeconds = Math.floor((Date.now() - new Date(dateString).getTime()) / 1000);
  if (diffInSeconds < 60) return 'Hace un momento';
  if (diffInSeconds < 3600) return `Hace ${Math.floor(diffInSeconds / 60)} min`;
  if (diffInSeconds < 86400) return `Hace ${Math.floor(diffInSeconds / 3600)} h`;
  if (diffInSeconds < 604800) return `Hace ${Math.floor(diffInSeconds / 86400)} d`;
  return new Date(dateString).toLocaleDateString('es-AR', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function activityCategory(action = '') {
  const value = String(action).toLowerCase();
  if (value.includes('factura') || value.includes('venta')) return 'ventas';
  if (value.includes('cliente')) return 'clientes';
  if (value.includes('pago') || value.includes('cobr')) return 'cobros';
  if (value.includes('egreso') || value.includes('gasto')) return 'egresos';
  if (value.includes('elimin') || value.includes('borr')) return 'eliminaciones';
  return 'otros';
}

const CATEGORY_META = {
  ventas: { label: 'Ventas', tone: 'blue' },
  clientes: { label: 'Clientes', tone: 'indigo' },
  cobros: { label: 'Cobros', tone: 'green' },
  egresos: { label: 'Egresos', tone: 'amber' },
  eliminaciones: { label: 'Eliminaciones', tone: 'red' },
  otros: { label: 'Otros', tone: 'gray' },
};

export function activityMeta(action = '') {
  const category = activityCategory(action);
  const meta = CATEGORY_META[category] || CATEGORY_META.otros;
  let Icon = FiActivity;
  if (category === 'ventas') Icon = FiFileText;
  else if (category === 'clientes') Icon = FiUsers;
  else if (category === 'cobros') Icon = FiDollarSign;
  else if (category === 'egresos') Icon = FiTrendingDown;
  else if (category === 'eliminaciones') Icon = FiTrash2;
  return { category, ...meta, Icon };
}

export function formatActivityDate(dateString) {
  if (!dateString) return '—';
  return new Date(dateString).toLocaleString('es-AR', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export const ACTIVITY_FILTERS = [
  { id: 'todos', label: 'Todos' },
  { id: 'ventas', label: 'Ventas' },
  { id: 'clientes', label: 'Clientes' },
  { id: 'cobros', label: 'Cobros' },
  { id: 'egresos', label: 'Egresos' },
  { id: 'otros', label: 'Otros' },
];
